import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteeTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'dateActioned',
];

const optionalColumnLabelFormat = {
  dateActioned: 'Date Actioned',
};

const AwaitingPaymentGuarantees = ({ TabsRaw }: any) => (
  <GuaranteeTableRecords
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    tabStatus="AWAITING_PAYMENT"
    defaultUrl={AdminRouteName.awaitingPaymentGuaranteesRoute}
    toggleStorageId="awaiting-payment-guarantee-table-col"
    hasNameAndImage
    permissionName="can-view-awaiting-payment-guarantees"
  />
);
export default AwaitingPaymentGuarantees;
